var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreepoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59906 9.85128C9.27434 9.85128 9.82177 9.30445 9.82177 8.62989C9.82177 7.95534 9.27434 7.40851 8.59906 7.40851C7.92378 7.40851 7.37636 7.95534 7.37636 8.62989C7.37636 9.30445 7.92378 9.85128 8.59906 9.85128Z",
    fill: "#D9E1FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3764 9.85128C15.0516 9.85128 15.5991 9.30445 15.5991 8.62989C15.5991 7.95534 15.0516 7.40851 14.3764 7.40851C13.7011 7.40851 13.1537 7.95534 13.1537 8.62989C13.1537 9.30445 13.7011 9.85128 14.3764 9.85128Z",
    fill: "#D9E1FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82176 9.85128C3.49704 9.85128 4.04447 9.30445 4.04447 8.62989C4.04447 7.95534 3.49704 7.40851 2.82176 7.40851C2.14648 7.40851 1.59906 7.95534 1.59906 8.62989C1.59906 9.30445 2.14648 9.85128 2.82176 9.85128Z",
    fill: "#D9E1FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreepoints);
export default __webpack_public_path__ + "static/media/threepoints.1732f0f791828f3e2a42c67c489a1b9e.svg";
export { ForwardRef as ReactComponent };